<div class="container-fluid">
  <div class="page-title">
    <div class="row align-items-center g-2">
      <div class="col-12 col-md-6 d-flex align-items-center overflow-hidden">
        @if (activeBackButton) {
          <button class="btn btn-outline-secondary me-2 me-md-3 flex-shrink-0" (click)="onBack()">
            <i class="fa fa-arrow-left"></i>
          </button>
        }
        @if (backLink) {
          <a
            class="page-title-back flex-shrink-0"
            [routerLink]="backLink"
            [attr.aria-label]="'btn.back' | translate"
            [ngbTooltip]="'btn.back' | translate"
            placement="bottom"
            container="body">
            <shared-feather-icons [icon]="'arrow-left'"></shared-feather-icons>
          </a>
        }
        <h3
          class="mb-0 text-truncate"
          [ngbTooltip]="title | translate"
          placement="bottom-start"
          container="body">
          {{ title | translate }}
        </h3>
      </div>
      <div
        class="col-12 col-md-6 d-flex align-items-center justify-content-start justify-content-md-end overflow-hidden">
        <ol
          class="breadcrumb mb-0 flex-nowrap align-items-center justify-content-start justify-content-md-end"
          [ngbTooltip]="fullBreadcrumbPath"
          placement="bottom-end"
          container="body">
          <li class="breadcrumb-item flex-shrink-0">
            <a
              [routerLink]="'/dashboard/default'"
              ngbTooltip="Inicio"
              placement="bottom"
              container="body">
              <svg class="stroke-icon">
                <use href="assets/svg/icon-sprite.svg#stroke-home"></use>
              </svg>
            </a>
          </li>
          <li class="breadcrumb-item flex-shrink-0" *ngFor="let item of items">
            <span [ngbTooltip]="item | translate" placement="bottom" container="body">
              {{ item | translate }}
            </span>
          </li>
          <li class="breadcrumb-item active flex-shrink-0">
            <span [ngbTooltip]="active_item | translate" placement="bottom-end" container="body">
              {{ active_item | translate }}
            </span>
          </li>
        </ol>
        <div
          class="breadcrumb-scroll-indicator d-md-none flex-shrink-0 ms-1"
          ngbTooltip="Desliza para ver más"
          placement="left"
          container="body">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </div>
  </div>
</div>
